import React from 'react';
import { bool, string } from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

function ListItem({ children, hide, description, amount, className, descriptionClassName, amountClassName }) {
  return hide ? null : (
    <div>
      <div className={cn(styles.itemList, className)}>
        {!!description && <span className={cn(styles.description, descriptionClassName)}>{description}</span>}
        {!!amount && <span className={cn(styles.amount, amountClassName)}>{amount}</span>}
      </div>
      {children ? <div>{children}</div> : null}
    </div>
  );
}

ListItem.propTypes = {
  amount: string,
  amountClassName: string,
  className: string,
  description: string,
  descriptionClassName: string,
  hide: bool
};

ListItem.defaultPropTypes = {
  hide: false
};

export default ListItem;
